// Mapeia os campos de ícone/cor do veículo (Vehicle.iconKey/iconColorMode/
// iconColor) de/para os `attributes` customizados de um device no Traccar:
// wp.vehicleType, wp.colorMode, wp.color.
//
// Prefixo "wp." evita colisão com qualquer atributo interno do Traccar (ex.:
// decoder.timezone, speedLimit) ou de outros protocolos/integrações — não é
// preciso alterar o schema do Traccar, `attributes` já é um JSON livre por
// device (tc_devices.attributes).
import type { Vehicle } from "@/types";

const ICON_KEY_ATTR = "wp.vehicleType";
const COLOR_MODE_ATTR = "wp.colorMode";
const COLOR_ATTR = "wp.color";
const MAP_ICON_ATTR = "wp.mapIcon";

export interface VehicleIconAttributes {
  iconKey?: string;
  iconColorMode?: "auto" | "fixed";
  iconColor?: string;
  mapIconStyle?: "model" | "photo";
}

export function readIconAttributes(
  attributes: Record<string, unknown> | undefined,
): VehicleIconAttributes {
  if (!attributes) return {};
  const colorMode = attributes[COLOR_MODE_ATTR];
  return {
    iconKey: typeof attributes[ICON_KEY_ATTR] === "string" ? (attributes[ICON_KEY_ATTR] as string) : undefined,
    iconColorMode: colorMode === "fixed" ? "fixed" : colorMode === "auto" ? "auto" : undefined,
    iconColor: typeof attributes[COLOR_ATTR] === "string" ? (attributes[COLOR_ATTR] as string) : undefined,
    mapIconStyle: attributes[MAP_ICON_ATTR] === "photo" ? "photo" : undefined,
  };
}

// Faz o merge de uma mudança parcial (iconKey/iconColorMode/iconColor) sobre
// os attributes já existentes do device, preservando todo o resto intacto.
export function mergeIconAttributes(
  current: Record<string, unknown> | undefined,
  patch: Partial<Pick<Vehicle, "iconKey" | "iconColorMode" | "iconColor" | "mapIconStyle">>,
): Record<string, unknown> {
  const next: Record<string, unknown> = { ...(current ?? {}) };
  if (patch.iconKey !== undefined) next[ICON_KEY_ATTR] = patch.iconKey;
  if (patch.iconColorMode !== undefined) next[COLOR_MODE_ATTR] = patch.iconColorMode;
  if (patch.iconColor !== undefined) next[COLOR_ATTR] = patch.iconColor;
  if (patch.mapIconStyle !== undefined) next[MAP_ICON_ATTR] = patch.mapIconStyle;
  return next;
}
